<template>
    <wire-frame-gdb>
        <template v-slot:navbar></template>
        <template v-slot:drawer></template>
        <template v-slot:main></template>
        <template v-slot:top-main-legend>
            <div class="text-disabled text-caption">
                selecione uma categoria...
            </div>
        </template>
    </wire-frame-gdb>
</template>
<script>
export default {
}
</script>